export default [
    {
        name: "Jusco - Rawang",
        lat: 3.3160041000000002,
        lng: 101.53579920000001,
    },
    {
        name: "Taman Tun Perak",
        lat: 3.30131345,
        lng: 101.58243585,
    },
    {
        name: "Taman Rahmat Jaya",
        lat: 3.2641432999999997,
        lng: 101.52240309999999,
    },
    {
        name: "Jalan Maxwell",
        lat: 3.3211684,
        lng: 101.5757797,
    },
    {
        name: "Taman Garing",
        lat: 3.3202104999999995,
        lng: 101.56123149999999,
    },
    {
        name: "Kampung Sungai Kertas",
        lat: 3.25499405,
        lng: 101.68576795,
    },
    {
        name: "Kampung Sungai Tua",
        lat: 3.2593470499999997,
        lng: 101.67882245,
    },
    {
        name: "SK Hulu Kelang",
        lat: 3.1990624999999997,
        lng: 101.7610751,
    }
]